import { GET_BIKE_MODEL_OVERVIEW_REQUEST, GET_BIKE_MODEL_OVERVIEW_REQUEST_SUCCESS, GET_BIKE_MODEL_OVERVIEW_REQUEST_FAILURE } from '../constants/get_bike_model_overview.constants';

export const getBikeModelOverviewRequest = (limit, offset, model_id) => ({
    type: GET_BIKE_MODEL_OVERVIEW_REQUEST, limit, offset, model_id,
});

export const getBikeModelOverviewRequestSuccess = bikes => ({
    type: GET_BIKE_MODEL_OVERVIEW_REQUEST_SUCCESS, bikes,
});

export const getBikeModelOverviewRequestFailure = error => ({
    type: GET_BIKE_MODEL_OVERVIEW_REQUEST_FAILURE, error,
});



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/Bike_model_update/redux/actions/get_bike_model_overview.actions.js